import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { responsiveFlavors as ResponsiveFlavorsPropType } from 'lib/CustomPropTypes';

import LazyLoad from 'components/LazyLoad';
import ImageCredit from 'components/ImageCredit';
import Picture from 'components/Picture';
import Placeholder from 'components/Picture/Placeholder';

import styles from './styles.module.scss';

const TeasePicture = ({
  responsiveFlavors,
  hidePlaceholder,
  className,
  lazyload,
  previewRedirect,
  type,
  ...remainingProps
}) => {
  if (!responsiveFlavors) return null;

  const {
    computedValues: { teaseImage } = {},
    placeholder,
    placeholderColor,
  } = remainingProps;

  if (!teaseImage && placeholder) {
    return (
      <Placeholder
        responsiveFlavors={responsiveFlavors}
        color={placeholderColor}
      />
    );
  }

  let picture = (
    <Picture
      className={classNames(
        'teasePicture',
        styles.container,
        { [className]: className },
      )}
      responsiveFlavors={responsiveFlavors}
      {...remainingProps}
    />
  );

  if (lazyload) {
    picture = (
      <LazyLoad
        placeholder={typeof placeholder === 'boolean' ? placeholder : !hidePlaceholder}
        placeholderColor={placeholderColor}
      >
        {picture}
      </LazyLoad>
    );
  }

  return (
    <>
      {picture}
      <ImageCredit
        type={type}
        responsiveFlavors={responsiveFlavors}
        {...remainingProps}
      />
    </>
  );
};

TeasePicture.propTypes = {
  responsiveFlavors: ResponsiveFlavorsPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.string,
  lazyload: PropTypes.bool,
  placeholder: PropTypes.bool,
  hidePlaceholder: PropTypes.bool,
  previewRedirect: PropTypes.bool,
};

TeasePicture.defaultProps = {
  responsiveFlavors: {},
  className: null,
  type: null,
  lazyload: true,
  placeholder: null,
  hidePlaceholder: false,
  previewRedirect: true,
};

export default TeasePicture;
